import { MessageFolderEnum } from "@/lib/enum/message-folder.enum";
import { PartnerMessageDataAccessLayer } from "@/store/modules/access-layers/partner-message.access-layer";

/**
 * Icon of the inbox navigation entry while at least one message waits to be read
 */
export const INBOX_ICON_UNREAD = "mdi-mailbox-up-outline";

/**
 * Icon of the inbox navigation entry while nothing waits to be read
 */
export const INBOX_ICON_READ = "mdi-mailbox-outline";

/**
 * The messages of the inbox folder that the user has not read yet.
 *
 * Counts what the app has loaded into the store so far - see `InboxStore.reset`, which registers a
 * message store per inbox of the partner. Nothing is fetched here: the navigation and the app bar
 * read this on every render.
 */
export function unreadInboxMessageCount(): number {
  let count = 0;

  // counted in one pass instead of `filter().length`, which allocates a second array per render
  for (const message of PartnerMessageDataAccessLayer.entities) {
    if (!message.isRead && message.folder === MessageFolderEnum.INBOX) {
      count++;
    }
  }

  return count;
}

/**
 * Icon of the inbox navigation entry, reflecting whether messages wait to be read.
 *
 * Configured as the icon of the entry instead of a fixed one, see `NavigationIcon`.
 */
export function inboxNavigationIcon(): string {
  return unreadInboxMessageCount() ? INBOX_ICON_UNREAD : INBOX_ICON_READ;
}
